import { useLayoutEffect } from 'react';

export const usePrepareLayout = () => {
    useLayoutEffect(() => {
        const header = document.getElementById('header-region');
        const footer = document.getElementById('footer-region');
        const root = document.getElementById('root');
        const body = document.getElementById('body');

        header?.classList.add('displayNone');
        footer?.classList.add('displayNone');
        root?.classList.add('whiteBg');
        body?.classList.add('whiteBg');

        return () => {
            header?.classList.remove('displayNone');
            footer?.classList.remove('displayNone');
            root?.classList.remove('whiteBg');
            body?.classList.remove('whiteBg');
        };
    }, []);
};
